import { useEffect, useMemo } from 'react';
import DependencyFlowHelper from '../../../helper/DependencyFlowHelper';
import { useDSCActions, useDSCGlobalStateStore } from '../context/selectors';

function useCommitReadyDataSources() {
  const { addDependencyFlows } = useDSCActions();
  const dsDependencyFlow = useDSCGlobalStateStore().hooks.dataSource.useDependencyFlow();
  const dsIntraDependencies = useDSCGlobalStateStore().hooks.dataSource.useIntraDependencies();

  const dsIdsWithFinishedDependents = useMemo(() => {
    // Only staging data source is filtered, as they are the only ones that can be committed
    const stagedDataSources = Object.keys(dsDependencyFlow).filter((key) =>
      DependencyFlowHelper.isDependencyStaging(dsDependencyFlow, key),
    );

    return stagedDataSources.filter((id) =>
      // Check if all dependencies are finished
      DependencyFlowHelper.areAllDependenciesFinished({
        dependencies: dsIntraDependencies?.[id],
        dependencyFlowInstance: dsDependencyFlow,
      }),
    );
  }, [dsDependencyFlow, dsIntraDependencies]);

  useEffect(() => {
    // these ids are ready to be committed
    if (dsIdsWithFinishedDependents.length) {
      addDependencyFlows(
        DependencyFlowHelper.createCommitDependencyFlow({
          ids: dsIdsWithFinishedDependents,
        }),
      );
    }
  }, [addDependencyFlows, dsIdsWithFinishedDependents]);
}

export default useCommitReadyDataSources;
